// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2icTj","location":"Header_location__KZPVI"};